import { useEffect, useState } from "react";

const useDeviceType = () => {
  const [result, setResult] = useState({
    deviceType: null,
    isMobile: false,
  });

  useEffect(() => {
    if (typeof navigator === "undefined" || typeof window === "undefined") {
      return;
    }

    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const maxTouchPoints = navigator.maxTouchPoints || 0;

    const isIOS =
      /iPhone|iPad|iPod/i.test(ua) ||
      (platform === "MacIntel" && maxTouchPoints > 1);

    const isAndroid = /Android/i.test(ua);

    const hasTouch =
      "ontouchstart" in window || maxTouchPoints > 0;

    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);

    const isSmallEnoughScreen =
      Math.min(window.screen.width, window.screen.height) <= 1024;

    const isMobile = navigator.userAgentData ? navigator.userAgentData.mobile :
      isMobileUA &&
      hasTouch &&
      maxTouchPoints > 0 &&
      isSmallEnoughScreen;

    let deviceType = null;
    if (isMobile) {
      if (isIOS) deviceType = "ios";
      else if (isAndroid) deviceType = "android";
    }
    
    
    setResult({
      deviceType,
      isMobile,
    });
  }, []);

  return result;
}

export default useDeviceType;